import { Box, Text } from '@factorialco/deprecated-design-system'

import type { ItemsType } from 'modules/bookkeepers/lib/incidenceTypeNavigation'

import NavItem from './NavItem'

interface Props {
  title: string
  items: ItemsType[]
}

const NavGroup = ({ title, items }: Props) => {
  return (
    <Box gap="s4">
      <Box paddingX="s6">
        <Text weight="bold" size="100" color="grey700" caps>
          {title}
        </Text>
      </Box>
      {items.map((item) => (
        <NavItem key={item.key} item={item} />
      ))}
    </Box>
  )
}

export default NavGroup
